import {axiosApi} from './helper'

export function sendContactMail(obj) {
  return axiosApi('contact/send', obj, 'post')
}
